import React, { useState } from 'react';
import { addAlert } from '../../actions/alerts.action';
import { useDispatch } from 'react-redux';
import { fetchManagerialDecisions } from '../../api/managerialDecision/managerialDecision.api';
import { useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';

import {
  makeStyles,
  CircularProgress,
  Container,
  Typography,
  useMediaQuery,
  useTheme
} from '@material-ui/core';

import Header from '../Header/Header';
import ManagerialDecisionItem from './ManagerialDecisionItem';
import { NAVIGATION_DRAWER_WIDTH } from '../../utils/const';

const useStyles = makeStyles({
  title: {
    color: '#999999',
    fontSize: '16px',
    textTransform: 'uppercase',
    margin: '40px auto 20px auto'
  }
});

const ManagerialDecisionsPage = () => {
  const theme = useTheme();
  const sm = useMediaQuery(theme.breakpoints.up('sm'));
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const classes = useStyles();
  const [ drawerOpen, setDrawerOpen ] = useState(false);

  const managerialDecisionsQuery = useQuery(
    [ 'managerialDecisions' ],
    async () => {
      const { data } = await fetchManagerialDecisions();
      return data;
    },
    {
      onError: error => {
        dispatch(addAlert({ message: error.message, severity: 'error' }));
      }
    }
  );

  const managerialDecisions = managerialDecisionsQuery.data;

  return (
    <>
      <Header drawerOpen={ drawerOpen } setDrawerOpen={ setDrawerOpen }/>
      <div style={ {
        marginLeft: !sm ? 'auto' : drawerOpen ? `${NAVIGATION_DRAWER_WIDTH}px` : '55px'
      } }>
        <Container>
          <Typography className={ classes.title }>
            {t('managerialDecisions.title')}
          </Typography>
          { !managerialDecisions && <CircularProgress/>}
          { managerialDecisions && managerialDecisions.length !== 0 &&
            <>
              {managerialDecisions.map(managerialDecision => (
                <ManagerialDecisionItem
                  key={ managerialDecision.id }
                  managerialDecision={ managerialDecision }
                  managerialDecisionsQuery={ managerialDecisionsQuery }
                />
              ))
              }
            </>
          }
          {
            managerialDecisions && managerialDecisions.length === 0 &&
            t('managerialDecisions.noManagerialDecisions')
          }
        </Container>
      </div>
    </>
  );
};

export default ManagerialDecisionsPage;
